import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=a4ff851c&scoped=true&"
import script from "./wxlogin.vue?vue&type=script&lang=js&"
export * from "./wxlogin.vue?vue&type=script&lang=js&"
import style0 from "./wxlogin.vue?vue&type=style&index=0&id=a4ff851c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./wxlogin.vue?vue&type=style&index=1&id=a4ff851c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff851c",
  null
  
)

export default component.exports